import React from 'react';
import ReactDOM from 'react-dom';
import { Form } from '../CMEProfileManagement/ModalForm';
import FocusTrap from 'focus-trap-react';
import '../../styles/dashboard.css';

export const Modal = ({
  onClickOutside,
  onKeyDown,
  modalRef,
  buttonRef,
  closeModal,
  onSubmit,
  onProfileCategoryChanges,
  onRequirerBoardChanges,
  stateOrSpecialtyBoard,
  profileCategory,
  filterProps,
  modalHeaderText,
  modalGeneralRequirementText,
  modalTopicRequirementText,
  modalFor,
  onKeyPress,
  handleChangeLicRenDate,
  inputProperties,
  topicList,
  topicLoaded,
  statuteLoaded,
  disableRequirement,
  closeModalCustomClick,
  cancelBtnRef,
  onChangeDate,
  currentProfessionalStatus,
  isFirstTimeAttestation,
  modalGeneralStatuteText,
  modalTopicStatuteText,
  statuteProperties,
  statuteTopicList
}) => {
  return ReactDOM.createPortal(
     
      <aside
        tag="aside"
        role="dialog"
        tabIndex="-1"
        aria-modal="true"
        className="modal-cover"
        onClick={onClickOutside}
        onKeyDown={onKeyDown}
      >
        <div className={modalFor === "Requirements" ? 'modal-area-profile modal-area' : modalFor === 'MobileUser' ? 'modal-area-mobile' : "modal-area"} ref={modalRef}>
          
        <div className={modalFor === "Requirements" ? "modal-header" : "" }>
          <div
            ref={buttonRef}
            aria-label="Close Modal"
            aria-labelledby="close-modal"
            className="_modal-close"
            onClick={closeModal}
          >
            <span id="close-modal" className="_hide-visual">
              Close
            </span>
            <svg className="_modal-close-icon" viewBox="0 0 40 40">
              <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
            </svg>
          </div>
           
          <div className={modalFor === 'MobileUser' ? 'model-header-text-mobile' : 'model-header-text'}  >
              {modalHeaderText}        
            </div>
       </div>
          {modalGeneralRequirementText
            ? <div className='model-header-requiement-text' dangerouslySetInnerHTML={{ __html: modalGeneralRequirementText }} />
            : <div className='model-header-requiement-text' />
          }

          {modalFor !== "Requirements" && (
          <div className="modal-body">
            <Form modalFor={modalFor}
                  closeModal={closeModal}
                  onSubmit={onSubmit}
                  profileCategory={profileCategory}
                  stateOrSpecialtyBoard = {stateOrSpecialtyBoard}
                  onProfileCategoryChanges = {onProfileCategoryChanges}
                  onRequirerBoardChanges={onRequirerBoardChanges}
                  filterProps={filterProps}
                  onKeyPress = {onKeyPress}
                  handleChangeLicRenDate ={handleChangeLicRenDate }
                  inputProperties={inputProperties}
                  closeModalCustomClick = {closeModalCustomClick}
                  cancelBtnRef = {cancelBtnRef}
                  onChangeDate={onChangeDate}
                  currentProfessionalStatus = {currentProfessionalStatus}
                  isFirstTimeAttestation = {isFirstTimeAttestation}
            />
          </div>
          )}

          {/* Statute Section with Separator - Only render if there's actual statute data */}
          {(() => {
            // Check if there's any actual statute content
            const hasGeneralStatute = statuteProperties?.modalData && statuteProperties.modalData.trim() !== '';
            const hasTopicStatute = statuteTopicList && statuteTopicList?.modalData && statuteTopicList.modalData.some(item => item.statute && item.statute.trim() !== '');
            const hasAnyStatute = hasGeneralStatute || hasTopicStatute;

            // Only render if there's statute data
            if (modalFor === "Requirements" && statuteLoaded && hasAnyStatute) {
              return (
                <>
                  <div className='statute-separator'>
                    <div className='separator-line'></div>
                    <div className='separator-text'>Statute</div>
                    <div className='separator-line'></div>
                  </div>

                  {/* General Statute Text */}
                  {hasGeneralStatute && (
                    <>
                      <div className='model-header-requiement-text'>
                        {modalGeneralStatuteText}
                      </div>
                      <div className="modal-requirement-body-stick-header">
                        <Form modalFor={modalFor}
                          closeModal={closeModal}
                          onSubmit={onSubmit}
                          profileCategory={profileCategory}
                          stateOrSpecialtyBoard={stateOrSpecialtyBoard}
                          onProfileCategoryChanges={onProfileCategoryChanges}
                          onRequirerBoardChanges={onRequirerBoardChanges}
                          filterProps={filterProps}
                          onKeyPress={onKeyPress}
                          handleChangeLicRenDate={handleChangeLicRenDate}
                          inputProperties={statuteProperties}
                          closeModalCustomClick={closeModalCustomClick}
                          cancelBtnRef={cancelBtnRef}
                          onChangeDate={onChangeDate}
                          currentProfessionalStatus={currentProfessionalStatus}
                          isFirstTimeAttestation={isFirstTimeAttestation}
                        />
                      </div>
                    </>
                  )}

                  {/* Topic Statute List */}
                  {statuteTopicList && statuteTopicList?.modalData && statuteTopicList.modalData.map((item, index) => (
                    item.statute && item.statute.trim() !== '' && (
                      <React.Fragment key={index}>
                        <div className={hasGeneralStatute || index > 0 ? 'border-bottom-requirement' : 'border-bottom-no-requirement'}>
                        </div>
                        <div className='model-header-topic-text'>
                          {item.description}
                        </div>

                        <div className="modal-topic-body">
                          <Form modalFor={modalFor}
                            closeModal={closeModal}
                            onSubmit={onSubmit}
                            profileCategory={profileCategory}
                            stateOrSpecialtyBoard={stateOrSpecialtyBoard}
                            onProfileCategoryChanges={onProfileCategoryChanges}
                            onRequirerBoardChanges={onRequirerBoardChanges}
                            filterProps={filterProps}
                            onKeyPress={onKeyPress}
                            handleChangeLicRenDate={handleChangeLicRenDate}
                            inputProperties={item.statute}
                            topicLoaded={topicLoaded} />
                        </div>

                        <div className='border-bottom-no-requirement'>
                        </div>
                      </React.Fragment>
                    )
                  ))}
                </>
              );
            }
            return null;
          })()}

        </div>
      </aside>
     ,
    document.body
  );
};

export default Modal;
